import { useContext, useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import router from 'src/router';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';

import { CssBaseline, Snackbar } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';

import { useAuth } from './hooks/useAuth';
import Spinner from './components/Spinner';
import { Helmet } from 'react-helmet-async';
import { AlertContext } from './contexts/AlertContext';

function App() {
  const { authenticate, isAuthenticated } = useAuth();
  const { handleToast, openToast, toastMessage } = useContext(AlertContext);
  useEffect(() => {
    void authenticate();
  }, []);

  const content = useRoutes(router);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        {!isAuthenticated ? <Spinner /> : content}
        <Helmet>
          <meta
            httpEquiv="refresh"
            content={`900;URL=${window.location.pathname}`}
          />{' '}
          {/* 900 seconds = 15 minutes */}
        </Helmet>
        <Snackbar
          open={openToast}
          autoHideDuration={5000}
          onClose={() => {
            handleToast(false);
          }}
          message={toastMessage}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        />
      </LocalizationProvider>
    </ThemeProvider>
  );
}
export default App;
